import { PDFDownloadLink } from "@react-pdf/renderer";
import { MenuItemStyled } from "pages/Orders/components/OrdersTable/components/RowActionsMenu";
import styled from "styled-components";

import { ClearOrderDocument, Props } from "./ClearOrderDocument";

const StyledPDFDownloadLink = styled(PDFDownloadLink)`
  text-decoration: none;
`;

type DownloadButtonProps = {
  data: Props;
  isLogoLoading?: boolean;
  /** CLE-3015 — a `TourAnchor` value for the menu item (`data-tour`). */
  tourAnchor?: string;
};

export function ClearOrderProDownloadButton({
  data,
  isLogoLoading = false,
  tourAnchor,
}: DownloadButtonProps) {
  // Show loading state while logo is being fetched
  if (isLogoLoading) {
    return (
      <MenuItemStyled
        type="button"
        disabled
        data-neutral="true"
        data-tour={tourAnchor}
        className="flex align-items-center gap-3"
      >
        <i className="pi pi-spin pi-spinner" />
        Loading...
      </MenuItemStyled>
    );
  }

  return (
    <MenuItemStyled
      as={StyledPDFDownloadLink}
      data-testid="download-pdf_OrderHeader_DownloadLink"
      data-neutral="true"
      data-tour={tourAnchor}
      className="flex align-items-center gap-3"
      document={<ClearOrderDocument {...data} />}
      fileName={`clear_order__${new Date().getTime()}.pdf`}
    >
      {({ loading }: { loading: boolean }) =>
        loading ? (
          <>
            <i className="pi pi-spin pi-spinner" />
            Loading...
          </>
        ) : (
          <>
            <i className="pi pi-download" />
            Download Good Faith Estimate (PDF)
          </>
        )
      }
    </MenuItemStyled>
  );
}
